import React from "react";
import "./Index.scss";
import call from "../../assets/images/call.svg";
import email from "../../assets/images/email.svg";

const Footer = ({}) => {
  const date = new Date();
  let year = date.getFullYear();
  return (
    <footer>
      <ul>
        <li>© {year},Liaise . All rights reserved.</li>
      </ul>
    </footer>
  );
};

export default Footer;
